import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useLanguage } from "../../Translations/LenguageContext";

const EditProjectModal = ({ show, handleClose, recordObject, fetchRecords }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [error, setError] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [projectId, setProjectId] = useState("");
    const [projectName, setProjectName] = useState("");
    const [projectDescription, setProjectDescription] = useState("");

    useEffect(() => {
        if (recordObject) {
            setProjectId(recordObject._id || "");
            setProjectName(recordObject.project_name || "");
            setProjectDescription(recordObject.project_description || "");
        }
    }, [recordObject]);

    const CloseModal = () => {
        setProjectId("");
        setProjectName("");
        setProjectDescription("");
        setError({message: "", display: false})
        handleClose()
    }

    const handleNavigatePath = (boolean) => {
        handleSave(boolean);
    };

    const handleSave = async () => {
        if (!projectName.trim()) {
            setError({ message: t.projects.new_project.err_name, display: true });
            return;
        }
        if (!projectDescription.trim()) {
            setError({ message: t.projects.new_project.err_desc, display: true });
            return;
        }

        setError({ message: "", display: false });

        const data = {
            user_id,
            project_id: projectId,
            project_name: projectName,
            project_description: projectDescription,
        };

        try {
            setLoading(true);
            const response = await fetch("https://backend.erioon.com/save_project", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);

            if (response.ok) {
                CloseModal()
                fetchRecords()
            } else {
                setError({
                    message: t.err_modify_general,
                    display: true,
                });
            }
        } catch (error) {
            setLoading(false);
            setError({
                message: t.err_modify_general,
                display: true,
            });
        }
    };


    return (
        <Modal show={show} onHide={CloseModal} className="modal_edit">
            <div className="modal_header">
                <p>{t.projects.update_project.title}</p>
                <i className="fa-solid fa-x" onClick={CloseModal}></i>
            </div>
            <div className="modal_body">
                <div className="label_input_section">
                    <label>{t.projects.new_project.name}</label>
                    <input
                        placeholder={t.projects.new_project.placeholder_name}
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                    />
                </div>
                <div className="label_input_section">
                    <label>{t.projects.new_project.description}</label>
                    <textarea
                        className="description_area_input"
                        placeholder={t.projects.new_project.placeholder_desc}
                        value={projectDescription}
                        onChange={(e) => setProjectDescription(e.target.value)}
                    />
                </div>

            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={() => handleNavigatePath(false)}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>{t.save}</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    )
}

export default EditProjectModal